module.exports = __webpack_public_path__ + "img/icon-message-mew.ec409d6d.svg";